// ABOUTME: RTK Query API slice for webshop subscription endpoints.
// ABOUTME: Handles fetching a single subscription, subscription prices, and creating checkout subscriptions.

import { apiSlice } from "../createApiSlice";

const SUBSCRIPTIONS_BASE = "/subscriptions";
const buildUrl = (endpoint) => SUBSCRIPTIONS_BASE + endpoint;
const ApiName = "Subscription";

const subscriptionApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getSubscription: builder.query({
            query: ({ externalId, type }) => ({
                url: buildUrl(`?externalId=${externalId}&type=${type}`),
                method: 'GET'
            }),
            providesTags: (result, error, arg) => [{ type: ApiName, id: arg.externalId }],
        }),
        getSubscriptionPrices: builder.query({
            query: (type) => ({
                url: buildUrl(`/prices?type=${type}`),
                method: 'GET'
            }),
            providesTags: (result, error, arg) => [{ type: ApiName, id: `prices-${arg}` }],
        }),
        createSubscription: builder.mutation({
            query: ({ type, externalId }) => ({
                url: buildUrl(``),
                method: 'POST',
                body: { type, externalId },
            }),
            invalidatesTags: (result, error, arg) => [{ type: ApiName, id: arg.externalId }],
        }),
        deactivateSubscription: builder.mutation({
            query: ({ id }) => ({
                url: buildUrl(`/${id}/deactivate`),
                method: 'POST',
            }),
            invalidatesTags: (result, error, arg) => [{ type: ApiName, id: arg.externalId }],
        }),
    })
});

export const {
    useGetSubscriptionQuery,
    useGetSubscriptionPricesQuery,
    useCreateSubscriptionMutation,
    useDeactivateSubscriptionMutation,
} = subscriptionApiSlice;
